import React, {useState} from "react"
import sound_helper from "sound_helper"
import PremiumPopover from "components/premium_popover"
import FaIcon from "components/fa_icon"

const AudioIcon = ({audio_url, can_play}) => {
  const [target, set_target] = useState(null)
  const [popover_is_open, set_popover_is_open] = useState(false)
  const on_click = () => {
    if (can_play) {
      sound_helper.play(audio_url, {ignore_muted: true})
    } else {
      set_popover_is_open(!popover_is_open)
    }
    return false
  }
  // span with nowrap and &#65279; prevents the icon to not wrap after text
  // https://snook.ca/archives/html_and_css/icon-wrap-after-text
  return (
    <>
      <span style={{whiteSpace: "nowrap"}} onClick={on_click} ref={set_target}>
        &#65279;
        <FaIcon name={"fa-volume-up"} text_aligned={true}/>
      </span>
      <PremiumPopover
        target={target}
        is_open={popover_is_open}
        on_close={() => set_popover_is_open(false)}
        element="image_gallery"
        placement="bottom"
      >
      </PremiumPopover>
    </>
  )
}

export default AudioIcon
